import defaultRestApi from "../common/RestApiInstance";
import _ from 'lodash';


export const DIRECTUS_PATH = "/web-cms/tables"
/**
 * Get the translation from directus. 
 * If params is ignored then it will be get all translations
 * params is array string
 */
const buildDirectusPath = (
  tableName, 
  params
) => {
  return (
    _.get(window.env, "directusHost", "")
    .concat(DIRECTUS_PATH)
    .concat(`/${tableName}`)
    .concat(`/rows?${
      params 
        ? `${params.toString()}` 
        : ''
      }`
    )
    .concat(`&access_token=${
      _.get(window.env, "directusToken", "")
    }`)    
  )
}

export default class DirectusService {

  /**
   * This function takes the params is table name and array string contains specific columns
   */
   static getData = (tableName, params) => {
      return defaultRestApi.get(buildDirectusPath(tableName, params), {
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      });
   }
}


// WEBPACK FOOTER //
// ./src/app/services/DirectusService.js